import CaseTypeStage from "../../entities/caseTypeStage";

/**
 * CaseTypeStage actions
 *
 * Call order:
 *
 * CASETYPESTAGE_SAVE_QUEUE:	adds the item to the save queue
 * --> CASETYPESTAGE_SAVE:	modifies the state
 * --> CASETYPESTAGE_SAVE_SUCCESS: if all went well
 * --> CASETYPESTAGE_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail CASETYPESTAGE_SAVE_QUEUE is during the call to CASETYPESTAGE_SAVE,
 * as adding an item to the queue should never fail.
 */

export const CASETYPESTAGE_FETCH_ONE_QUEUE: any = 'CASETYPESTAGE_FETCH_ONE_QUEUE';
export const CASETYPESTAGE_FETCH_SUCCESS: any = 'CASETYPESTAGE_FETCH_SUCCESS';
export const CASETYPESTAGE_FETCH_FAILURE: any = 'CASETYPESTAGE_FETCH_FAILURE';
export const CASETYPESTAGE_FETCH_ONE_SUCCESS: any = 'CASETYPESTAGE_FETCH_ONE_SUCCESS';
export const CASETYPESTAGE_FETCH_ONE_FAILURE: any = 'CASETYPESTAGE_FETCH_ONE_FAILURE';

export const CASETYPESTAGE_SAVE: any = 'CASETYPESTAGE_SAVE';
export const CASETYPESTAGE_SAVE_QUEUE: any = 'CASETYPESTAGE_SAVE_QUEUE';
export const CASETYPESTAGE_SAVE_SUCCESS: any = 'CASETYPESTAGE_SAVE_SUCCESS';
export const CASETYPESTAGE_SAVE_FAILURE: any = 'CASETYPESTAGE_SAVE_FAILURE';

export const CASETYPESTAGE_SAVE_MANY: any = 'CASETYPESTAGE_SAVE_MANY';
export const CASETYPESTAGE_SAVE_MANY_QUEUE: any = 'CASETYPESTAGE_SAVE_MANY_QUEUE';
export const CASETYPESTAGE_SAVE_MANY_SUCCESS: any = 'CASETYPESTAGE_SAVE_MANY_SUCCESS';
export const CASETYPESTAGE_SAVE_MANY_FAILURE: any = 'CASETYPESTAGE_SAVE_MANY_FAILURE';

export const CASETYPESTAGE_REMOVE: any = 'CASETYPESTAGE_REMOVE';
export const CASETYPESTAGE_REMOVE_QUEUE: any = 'CASETYPESTAGE_REMOVE_QUEUE';
export const CASETYPESTAGE_REMOVE_SUCCESS: any = 'CASETYPESTAGE_REMOVE_SUCCESS';
export const CASETYPESTAGE_REMOVE_FAILURE: any = 'CASETYPESTAGE_REMOVE_FAILURE';

export const CASETYPESTAGE_RESTORE: any = 'CASETYPESTAGE_RESTORE';
export const CASETYPESTAGE_RESTORE_QUEUE: any = 'CASETYPESTAGE_RESTORE_QUEUE';
export const CASETYPESTAGE_RESTORE_SUCCESS: any = 'CASETYPESTAGE_RESTORE_SUCCESS';
export const CASETYPESTAGE_RESTORE_FAILURE: any = 'CASETYPESTAGE_RESTORE_FAILURE';

export const CASETYPESTAGE_RESTORE_MANY: any = 'CASETYPESTAGE_RESTORE_MANY';
export const CASETYPESTAGE_REMOVE_MANY: any = 'CASETYPESTAGE_REMOVE_MANY';

/* Fetch actions */
export const fetchCaseTypeStageSuccess = (caseTypeStages: CaseTypeStage[], partial: boolean, lastFetch: number) => ({type: CASETYPESTAGE_FETCH_SUCCESS, caseTypeStages, partial, lastFetch});
export const fetchCaseTypeStageFailure = (err: any) => {
		console.error('CaseTypeStageAction: fetchCaseTypeStageFailure', err);
		return {type: CASETYPESTAGE_FETCH_FAILURE, err};
};
export const fetchOneCaseTypeStageQueue = (caseTypeStageId: string) => ({type: CASETYPESTAGE_FETCH_ONE_QUEUE, caseTypeStageId});
export const fetchOneCaseTypeStageSuccess = (caseTypeStage: CaseTypeStage) => ({type: CASETYPESTAGE_FETCH_ONE_SUCCESS, caseTypeStage});
export const fetchOneCaseTypeStageFailure = (id: string, err: any) => {
		console.error('CaseTypeStageAction: fetchOneCaseTypeStageFailure', err);
		return {type: CASETYPESTAGE_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveCaseTypeStage = (caseTypeStage: CaseTypeStage) => {
    // console.debug('⮂ CASETYPESTAGE_SAVE action', caseTypeStage?.id);
    return {type: CASETYPESTAGE_SAVE, caseTypeStage};
}
export const saveCaseTypeStageQueue = (caseTypeStage: CaseTypeStage, onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ CASETYPESTAGE_SAVE_QUEUE action', caseTypeStage?.id);
    return {type: CASETYPESTAGE_SAVE_QUEUE, caseTypeStage, onQueued};
}
export const saveCaseTypeStageSuccess = (caseTypeStage: CaseTypeStage) => {
    // console.debug('⮂ CASETYPESTAGE_SAVE_SUCCESS action', caseTypeStage?.id);
    return {type: CASETYPESTAGE_SAVE_SUCCESS, caseTypeStage};
}
export const saveCaseTypeStageFailure = (caseTypeStage: CaseTypeStage, status: number, message: string) => {
    console.warn(`⮂ CASETYPESTAGE_SAVE_FAILURE error saving caseTypeStage: HTTP ${status}: ${message}`, caseTypeStage?.id);
    return {type: CASETYPESTAGE_SAVE_FAILURE, caseTypeStage, status, message};
};

/* SaveMany actions */
export const saveManyCaseTypeStages = (caseTypeStages: CaseTypeStage[]) => {
    // console.debug('⮂ CASETYPESTAGE_SAVE_MANY action', caseTypeStages?.map(caseTypeStage => caseTypeStage?.id).join(','));
    return {type: CASETYPESTAGE_SAVE_MANY, caseTypeStages};
}
export const saveManyCaseTypeStagesQueue = (caseTypeStages: CaseTypeStage[], onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ CASETYPESTAGE_SAVE_MANY_QUEUE action', caseTypeStages?.map(caseTypeStage => caseTypeStage.id).join(','));
    return {type: CASETYPESTAGE_SAVE_MANY_QUEUE, caseTypeStages, onQueued};
}

export const saveManyCaseTypeStagesSuccess = (caseTypeStages: CaseTypeStage[]) => {
    // console.debug('⮂ CASETYPESTAGE_SAVE_MANY_SUCCESS action', caseTypeStages?.map(caseTypeStage => caseTypeStage.id).join(','));
    return {type: CASETYPESTAGE_SAVE_MANY_SUCCESS, caseTypeStages};
}
export const saveManyCaseTypeStagesFailure = (caseTypeStages: CaseTypeStage[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_CASETYPESTAGES_FAILURE Error saving caseTypeStages: HTTP ${status}: ${message}`, caseTypeStages?.map(caseTypeStage => caseTypeStage.id).join(','));
		return {type: CASETYPESTAGE_SAVE_MANY_FAILURE, caseTypeStages, status, message};
};

/* Remove actions */
export const removeCaseTypeStage = (caseTypeStage: CaseTypeStage) => ({ type: CASETYPESTAGE_REMOVE, caseTypeStage });
export const removeCaseTypeStageQueue = (caseTypeStage: CaseTypeStage) => ({ type: CASETYPESTAGE_REMOVE_QUEUE, caseTypeStage });
export const removeCaseTypeStageSuccess = (caseTypeStage: CaseTypeStage) => ({ type: CASETYPESTAGE_REMOVE_SUCCESS, caseTypeStage });
export const removeCaseTypeStageFailure = (caseTypeStage: CaseTypeStage, status: number, message: string) => {
	console.error(`Redux: removeCaseTypeStageFailure Error removing caseTypeStage: HTTP ${status}: ${message}`);
	return ({ type: CASETYPESTAGE_REMOVE_FAILURE, caseTypeStage, status, message });
};

/* Restore actions */
export const restoreCaseTypeStage = (caseTypeStage: CaseTypeStage) => ({ type: CASETYPESTAGE_RESTORE, caseTypeStage });
export const restoreCaseTypeStageQueue = (caseTypeStage: CaseTypeStage) => ({ type: CASETYPESTAGE_RESTORE_QUEUE, caseTypeStage });
export const restoreCaseTypeStageSuccess = (caseTypeStage: CaseTypeStage) => ({ type: CASETYPESTAGE_RESTORE_SUCCESS, caseTypeStage });
export const restoreCaseTypeStageFailure = (caseTypeStage: CaseTypeStage, status: number, message: string) => {
	console.error(`Redux: restoreCaseTypeStageFailure Error restoring caseTypeStage: HTTP ${status}: ${message}`);
	return ({ type: CASETYPESTAGE_RESTORE_FAILURE, caseTypeStage, status, message });
};

/* RestoreMany actions */
export const restoreManyCaseTypeStages = (caseTypeStages: CaseTypeStage[]) => ({ type: CASETYPESTAGE_RESTORE_MANY, caseTypeStages });

/* RemoveMany actions */
export const removeManyCaseTypeStages = (caseTypeStages: CaseTypeStage[]) => ({ type: CASETYPESTAGE_REMOVE_MANY, caseTypeStages });